import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';

import StatisticsAudienceOverlapStatusChecker from 'modules/statistics/components/StatisticsAudienceOverlapStatusChecker';

import {
  fetchAudienceOverlapLists,
  resetAudienceOverlap
} from 'modules/statistics/reducers/statistics-audience-overlap';

type OwnProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  orgId: number, // used in mapDispatchToProps,
  // eslint-disable-next-line react/no-unused-prop-types
  listId: number, // used in mapDispatchToProps,
  children: React.ReactNode,
  onShowCreators: () => void
};

type DispatchProps = {
  dispatchFetchAudienceOverlap: (b: number, a: number) => void,
  dispatchResetAudienceOverlap: () => void
};

type Props = OwnProps & DispatchProps;

const ListStatsOverlapStatusChecker = (props: Props) => {
  const { children, orgId, listId, dispatchFetchAudienceOverlap, dispatchResetAudienceOverlap, onShowCreators } = props;

  React.useEffect(() => {
    dispatchFetchAudienceOverlap(orgId, listId);
    return () => {
      dispatchResetAudienceOverlap();
    };
  }, [orgId, listId]);

  const actionButton = <ActionButton onClick={onShowCreators}>Edit Collection</ActionButton>;

  return (
    <StatisticsAudienceOverlapStatusChecker
      actionButton={actionButton}
    >
      {children}
    </StatisticsAudienceOverlapStatusChecker>
  );
};

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchAudienceOverlap: (orgId: number, listId: number) => dispatch(fetchAudienceOverlapLists(orgId, listId)),
  dispatchResetAudienceOverlap: (): void => dispatch(resetAudienceOverlap())
});

export default connect(null, mapDispatchToProps)(ListStatsOverlapStatusChecker);
